import AppConfig from "../../config/AppConfig";
import Configuration from "../../config/configuration";
import { gapi } from "gapi-script";

const CALENDAR_SCOPES = "https://www.googleapis.com/auth/calendar.readonly https://www.googleapis.com/auth/calendar.events";

class Calendar {
  constructor() {
    this.lastQuery = {};
    this.retryIntervalMs = 600 * 1000;
    this.backfillDays = 7;
    this.authPending = false;
    this.result = {};

    this.offlineMode = AppConfig.GOOGLE_CLIENT_OFFLINE;

    const configuration = new Configuration();
    this.config = {
      client_id: configuration.GOOGLE_CLIENT_ID,
      apiKey: configuration.GOOGLE_API_KEY,
      scope: CALENDAR_SCOPES,
      discoveryDocs: [
        "https://www.googleapis.com/discovery/v1/apis/calendar/v3/rest",
      ],
      immediate: true,
    };
    //console.log(config)
  }

  authorizeIntegration(controller, type, maxEvents, forceRead, eventsCallback) {
    const that = this;
    const config = this.config;

    console.log("Authorize " + (this.offlineMode ? "offline" : "online"))

    if (type == "native") {
      //do nothing
    } else if (type == "google" && this.offlineMode && window.embeddedLogin && window.embeddedLogin.calendarLogin) {
      window.embeddedAuthorizeCalendarCallback = eventsCallback;
      window.embeddedLogin.calendarLogin();
    } else if (type == "google" && this.offlineMode) {
        function auth() {
          const configInit = JSON.parse(JSON.stringify(config));
          configInit.immediate = false;
          configInit.redirect_uri = 'postmessage';
          configInit.approval_prompt = 'force';

          gapi.client.init(configInit).then(function () {
            var auth2 = gapi.auth2.getAuthInstance();
            auth2.grantOfflineAccess(configInit).then((data) => {
              console.log("Authorized");
              const grantToken = data.code;
              var profile = auth2.currentUser.get().getBasicProfile();

              //console.log(grantToken);
              const action = {
                action: "save",
                target: "token",
                account: "", //profile?.getEmail(),
                code: grantToken,
                device: "web"
              };
              controller.apiService.cardAction(action).then((reply) => {
                const account = reply.id; //profile?.getEmail();
                eventsCallback(type, null, account);
              });

            });
          });
        }
        gapi.load("client", auth);
    } else if (type == "google") {
        function callback(authResult) {
          try {
            if (authResult && authResult.status && authResult.status.signed_in) {
              console.log("Calendar auth succeeded, immediate true");
              that.getEvents(controller, type, maxEvents, forceRead, eventsCallback);
            } else if (!that.authPending) {
              that.authPending = true;
              console.log("Calendar auth failed");
              console.log(authResult);
              if (config.immediate) {
                config.immediate = false;
                gapi.auth2
                    .getAuthInstance()
                    .signIn()
                    .then(
                        function () {
                          console.log("Calendar auth succeeded, immediate false");
                          that.getEvents(controller, type, maxEvents, forceRead, eventsCallback);
                        },
                        function (error) {
                          if (error) {
                            console.log(
                                "Popup could not open to sign in for calendar",
                            );
                          }
                        },
                    );
              }
            }
          } catch (e) {
            console.log(e);
          }
        }

        function auth() {
          const configInit = JSON.parse(JSON.stringify(config));
          configInit.immediate = false;
          console.log(gapi)
          gapi.client.init(configInit).then(function () {
            gapi.auth.authorize(configInit, callback);
          });
        }
        gapi.load("client", auth);
    }
  }

  updateEvents(type, eventsMap, eventsCallback) {
    if (eventsMap != null) {
      var evtCleaned = [];
      const keys = Object.keys(eventsMap);
      for (var k in keys) {
        const key = keys[k];
        const events = eventsMap[key];
        for (var i = 0; i < events.length; i++) {
          var event = events[i];
          if (event != null) {
            var startTime = event.start.dateTime;
            if (!startTime) startTime = event.start.date;
            var endTime = event.end.dateTime;
            if (!endTime) endTime = event.end.date;
            const isTimedEvent =
                startTime &&
                startTime.length > 10 &&
                endTime &&
                endTime.length > 10;
            if (isTimedEvent) {
              //console.log(event);
              const evt = {
                calId: "google:" + key,
                start: startTime,
                end: endTime,
                name: event.summary,
                location: event.location,
                description: event.description,
                attendees: event.attendees ? event.attendees.map((t) => t.displayName) : null,
                url: event.htmlLink,
              };
              //const isDuplicate = evtCleaned.some(item => item.calId === evt.calId && item.start === evt.start && item.end === evt.end && item.name === evt.name);
              evtCleaned.push(evt);
            }
          }
        }
      }

      //console.log(evtCleaned);
      console.log("Total events: " + evtCleaned.length);
      var auth2 = gapi.auth2.getAuthInstance();
      var profile = auth2.currentUser.get().getBasicProfile();
      eventsCallback(type, evtCleaned, profile.getEmail());
    }
  }

  isCalendarIncluded(controller, cal) {
    const calendarSource = "google";
    const calendarNameKey = "calendar:" + calendarSource + ":" + (cal.summary || "").substring((cal.summary || "").indexOf(" ") + 1);
    const isIncluded = !!controller.state.settings?.integrations[calendarNameKey];
    //const isIncluded = calendarExclusions == null || !calendarExclusions.includes(cal.id);
    return isIncluded;
  }


  async getCalendarEvents(cal, maxEvents, forceRead) {
    const calendar = this;
    const calendarId = cal.id;
    var now = +new Date();
    const lastQuery = calendar.lastQuery[calendarId] || 0;
    if (now - lastQuery < calendar.retryIntervalMs && !forceRead) return;
    calendar.lastQuery[calendarId] = +new Date();
    console.log("Retrieving events from " + cal.summary + " " + cal.id);

    var d = new Date(
        new Date().getTime() - calendar.backfillDays * 60 * 60 * 24 * 1000,
    );
    console.log("From " + d.toISOString());
    try {
      const response = await gapi.client.calendar.events.list({
        calendarId: calendarId,
        timeMin: d.toISOString(),
        showDeleted: false,
        singleEvents: true,
        maxResults: maxEvents,
        orderBy: "startTime",
      });
      var events = response.result.items;
      console.log(
          "Retrieved events, count: " + (events != null ? events.length : 0),
      );
      return events;
    } catch (reason) {
      console.log("Events retrieval failed");
      console.log(reason);
      return null;
    }
  }

  async getEvents(controller, type, maxEvents, forceRead, eventsCallback) {
    if (this.offlineMode) return;

    const clist = await gapi.client.calendar.calendarList.list({
      accessRole: "owner",
    });
    const calendars = clist.result.items;
    //console.log(calendars);
    this.result = {};
    if (calendars != null) {
      for (var i = 0; i < calendars.length; i++) {
        const cal = calendars[i];
        if (this.isCalendarIncluded(controller, cal)) {
          //console.log(cal.id)
          const events = await this.getCalendarEvents(cal, maxEvents, forceRead);
          if (events != null && events.length > 0) {
            this.result[cal.id + " " + cal.summary] = events;
          }
        }
      }

      //console.log(calendar.result)
      this.updateEvents(type, this.result, eventsCallback);
    }
  }


  pullEvents(
    controller,
    type,
    calendarExclusions,
    maxEvents,
    forceRead,
    eventsCallback,
  ) {
    if (this.offlineMode) return;

    const calendar = this;
    const config = this.config;

    function start() {
      function callback(authResult) {
        try {
          if (authResult && authResult.status && authResult.status.signed_in) {
            console.log("Calendar auth succeeded, immediate true");
            calendar.getEvents(controller, type, maxEvents, forceRead, eventsCallback);
          } else if (!calendar.authPending) {
            console.log("Calendar auth failed");
            console.log(authResult);
          }
        } catch (e) {
          console.log(e);
        }
      }

      const configInit = JSON.parse(JSON.stringify(config));
      configInit.immediate = true;
      gapi.client.init(configInit).then(function () {
        gapi.auth.authorize(config, callback);
      });
    }

    gapi.load("client", start);
  }
}

export { Calendar };
